<template>
  <Toolbar class="mb-4 md:w-11">
    <template #start> </template>
    <template #end>
      <Button
        label="Nueva solicitud"
        icon="pi pi-plus"
        severity="primary"
        class="mr-2 font-semibold text-sm"
        @click="$emit('open')"
      />
    </template>
  </Toolbar>
</template>
<script setup lang="ts">
  import Toolbar from 'primevue/toolbar'
  import Button from 'primevue/button'

  defineEmits<{ (e: 'open'): void }>()
</script>
